import React from "react";
import "./style.css";

interface BreadCrumbProps {
  path: string[];
  navigateTo: (path: string[], children: [], isbreadcrumb: boolean) => void;
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ path, navigateTo }) => {
  // Prepend "Documents" to the path for display
  const fullPath = ["Documents", ...path];

  return (
    <div className="document_breadcrumb">
      {fullPath.map((segment, index) => (
        <span
          key={index}
          onClick={
            () =>
              index < fullPath.length - 1
                ? navigateTo(fullPath.slice(1, index + 1), [], true)
                : null // Clicking the last item does nothing
          }
          className={index === fullPath.length - 1 ? "breadcrumb_active" : ""}
        >
          {segment}
          {index < fullPath.length - 1 && " / "}
        </span>
      ))}
    </div>
  );
};

export default BreadCrumb;
